<script setup lang="ts">
import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { computed } from 'vue';

import LegProductsTablesSection from '@/components/sections/LegProductsTablesSection.vue';
import PreviewDiagramNewAirRoadSection from '@/components/sections/PreviewDiagramNewAirRoadSection.vue';

export interface Props {
  bookingArJob?: ReadonlyDeep<
    openapi.JobsToAirroad2ListContentOpenapi['results'][0]
  >;
}
export type TableFoldProps = Props;
const props = withDefaults(defineProps<Props>(), {
  bookingArJob: undefined,
});

// TODO similar to @/components/tableFolds/BookedAirRoadTableFold.vue
const arStops = computed(() => {
  // TODO
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!props.bookingArJob?.stops?.length) return [];
  return props.bookingArJob.stops.map((stop) => {
    return {
      stop_number: stop.stop_number,
      name: stop.name,
      suburb: stop.suburb,
      state: stop.state,
      postcode: stop.post_code,
      address_line_1: stop.address_line_1,
      address_line_2: stop.address_line_2,
    };
  });
});
</script>

<template>
  <section
    data-testid="jobsAirRoadTableFold"
    :class="$style.jobsAirRoadTableFold"
  >
    <PreviewDiagramNewAirRoadSection
      :ar-stops="arStops"
      :job="props.bookingArJob"
      :is-fold="true"
    />
    <LegProductsTablesSection
      v-if="props.bookingArJob?.stops?.length"
      :stops="props.bookingArJob.stops"
    />
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.jobsAirRoadTableFold {
}
</style>
